import { IComponentOptions } from "angular";
import { ChangeJournalViewComponentItemController } from "../../../../../records/changeJournal/changeJournalViewComponent/itemObjectDetail/componentController";

export const vsComponentName = "changeJournalMachineConfigurationItemView";
export const changeJournalMachineConfigurationItemViewComponentOptions: IComponentOptions =
  {
    template: require("!html-loader!./index.html").default,
    controller: ChangeJournalViewComponentItemController,
    controllerAs: "itemController",
    bindings: {
      logItem: "<",
    },
  };
